import { render, staticRenderFns } from "./bResumeEntry.vue?vue&type=template&id=08a8b22e&"
import script from "./bResumeEntry.vue?vue&type=script&lang=js&"
export * from "./bResumeEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports